<template>
    <div class="dashboard">
        <div class="content-area">
            <base-header
                :menu-listing="menuListing"
                @sidemenu="$emit('responsiveSideBar')"
            ></base-header>
            <div class="right-panel">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            menuListing: [
                {
                    anchorLink: '/configuration/',
                    menuLabel: 'Idenfo Engine',
                    name: 'idenfo-engine',
                    permission: ['idenfo-engine'],
                },
                {
                    anchorLink: '/configuration/screening-data/',
                    menuLabel: 'Screening Data',
                    name: 'gender',
                    permission: ['view-screening-data'],
                },
                {
                    anchorLink: '/configuration/form-builder/',
                    menuLabel: 'Form Builder',
                    name: 'form-builder-setup-profile',
                    permission: ['form-builder'],
                },
                {
                    anchorLink: '/configuration/simulate/',
                    menuLabel: 'Simulate',
                    name: 'initiate-simulation-process',
                    permission: ['initiate-simulation-process'],
                },
                {
                    anchorLink: '/configuration/on-boarding-configuration/',
                    menuLabel: 'On Boarding Configuration',
                    name: 'on-boarding-configuration',
                    permission: ['ocr'],
                },
                {
                    anchorLink: '/configuration/branding/',
                    menuLabel: 'Branding',
                    name: 'branding',
                    permission: ['branding'],
                },
            ],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > methods
} // End of export default
</script>
